import styled from "styled-components";

const Card = styled.div`
  padding: 0.4rem;
  margin-bottom: 1rem;
`;

export default Card;
